import { supabase } from '../auth/supabaseClient'

export async function isAdmin(): Promise<boolean> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    const userId = auth.session?.user?.id
    if (!userId) return false
    const { data, error } = await supabase.from('profiles').select('is_admin').eq('user_id', userId).maybeSingle()
    if (error || !data) return false
    return !!(data as any).is_admin
  } catch {
    return false
  }
}
